<script setup lang="ts">
/**
 * Sidens AI-indikator ([D-439], 12-conventions §95): sidder i FilterShell
 * mellem titel og knapper på ALLE sider og viser de 3 lysegrå prikker + hvad
 * AI arbejder på, når en sprogmodel- eller billedkørsel hører til siden. Ligger
 * centralt, så ingen side kan glemme den. Siderne viser desuden selv
 * fremdriften der, hvor kørslen startes (<AiIcon :busy />, statuslinjer).
 *
 * Sider der skjuler den fælles header (meta.showHeader: false) og har
 * AI-arbejde, sætter komponenten ved deres egen overskrift (fx Handlinger).
 * Placeringen styres af kalderens class.
 */

import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import { aiActivityForPage, aiActivityTip, startAiActivityPolling } from '../composables/useAiActivity';
import AiDots from './AiDots.vue';

const route = useRoute();
const items = computed(() => aiActivityForPage(route.path));
const label = computed(() => {
  const list = items.value;
  if (list.length === 0) return '';
  const first = list[0]!.label;
  return list.length === 1 ? first : `${first} og ${list.length - 1} mere`;
});

onMounted(() => startAiActivityPolling());
</script>

<template>
  <AiDots
    v-if="items.length > 0"
    :label="label"
    hide-label-on-mobile
    :tip="aiActivityTip(items)"
    data-testid="ai-activity-page"
  />
</template>
